export * from './InformationIcon';
